export * from './InformationIcon';
